"use client"

import { useState } from "react"
import { FaPlus, FaStickyNote, FaTruckLoading } from "react-icons/fa"
import { useObservations } from "../context/ObservationContext"
import ObservationItem from "./ObservationItem"
import ObservationModal from "./ObservationModal"
import "./ObservationList.css"
import { AiOutlineLoading } from "react-icons/ai"

const ObservationList = ({ selectedDate }) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [editingObservation, setEditingObservation] = useState(null)

  const { getObservationsForDate, loading  } = useObservations()

  // Obter apenas as observações da data selecionada
  const dateObservations = getObservationsForDate(selectedDate)

  const handleAddObservation = () => {
    setEditingObservation(null)
    setIsModalOpen(true)
  }

  const handleEditObservation = (observation) => {
    setEditingObservation(observation)
    setIsModalOpen(true)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
    setEditingObservation(null)
  }

  // Formatar a data para exibição
  const d = selectedDate.split("-")
  const formattedDate = `${d[2]}/${d[1]}/${d[0]}`

  return (
    <div className="observations-container">
      {loading && <div className="loading"><AiOutlineLoading size="50px"/></div>}
      <div className="observations-header">
        <h2>
          <FaStickyNote className="icon-left" />
          Observações para {formattedDate}
        </h2>
        <button className="btn btn-primary" onClick={handleAddObservation}>
          <FaPlus className="icon-left" /> Nova Observação
        </button>
      </div>

      {dateObservations.length > 0 ? (
        <div className="observations-grid">
          {dateObservations.map((observation) => (
            <ObservationItem
              key={observation.id}
              observation={observation}
              onEdit={() => handleEditObservation(observation)}
            />
          ))}
        </div>
      ) : (
        <div className="no-observations">
          <p>Nenhuma observação para esta data</p>
          <button className="btn btn-primary" onClick={handleAddObservation}>
            <FaPlus className="icon-left" /> Adicionar Observação
          </button>
        </div>
      )}

      {isModalOpen && (
        <ObservationModal
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          observation={editingObservation}
          selectedDate={selectedDate}
        />
      )}
    </div>
  )
}

export default ObservationList

